/**
 * Extract numeric level from any priority/level format
 * Utility function to normalize different level representations to a numeric value (1-5)
 * 
 * @param {string} levelString - The level string in any format:
 *   - "P1", "P2", "P3", "P4", "P5"
 *   - "Foundational (Level 1)", "Hygiene (Level 2)", "Governed (Level 3)", etc.
 *   - "Level 1", "Level 2", etc.
 * @returns {number|null} Numeric level (1-5) or null if not found
 * 
 * @example
 * extractNumericLevel("P1") // returns 1
 * extractNumericLevel("P3") // returns 3
 * extractNumericLevel("Foundational (Level 1)") // returns 1
 * extractNumericLevel("Hygiene (Level 2)") // returns 2
 * extractNumericLevel("Governed (Level 3)") // returns 3
 * extractNumericLevel("Level 4") // returns 4
 * extractNumericLevel("invalid") // returns null
 */
function extractNumericLevel(levelString) {
	if (!levelString || typeof levelString !== 'string') {
		return null;
	}
	
	// Match patterns like "P1", "P2", "P3", "P4", "P5"
	const pMatch = levelString.match(/^P([1-5])$/);
	if (pMatch) {
		return parseInt(pMatch[1], 10);
	}
	
	// Match patterns like "Level 1", "Level 2", "(Level 3)", "Foundational (Level 1)", etc.
	const levelMatch = levelString.match(/Level\s*(\d)/i);
	if (levelMatch) {
		const level = parseInt(levelMatch[1], 10);
		// Validate it's in the 1-5 range
		if (level >= 1 && level <= 5) {
			return level;
		}
	}
	
	return null;
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = extractNumericLevel;
} else if (typeof window !== 'undefined') {
	window.extractNumericLevel = extractNumericLevel;
}

